module.exports = __webpack_public_path__ + "static/media/AB_iPhoneX_Instagram.136bcf01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile_header/AB_iPhoneX_Instagram.png
// module id = 539
// module chunks = 0